module.exports = __webpack_public_path__ + "img/step5.091049b9.png";